/*
 * @Autor: lh
 * @Date: 2022-05-31 14:27:37
 * @LastEditors: hl
 * @LastEditTime: 2022-12-12 12:22:18
 * @Description: 
 */
import Vue from 'vue'
import 'mint-ui/lib/style.css'
import '@/static/css/styles.scss'


// import './static/css/mint-ui.scss'
// import Mint from 'mint-ui'
// Vue.use(Mint)
import { 
    // Swipe, 
    // SwipeItem, 
    InfiniteScroll, 
    Spinner, 
    Cell, 
    Popup, 
    Picker, 
    DatetimePicker, 
    Loadmore, 
    Switch, 
    Navbar, 
    TabItem, 
    TabContainer, 
    TabContainerItem } from 'mint-ui';
// Vue.component(Swipe.name, Swipe);
// Vue.component(SwipeItem.name, SwipeItem);
Vue.use(InfiniteScroll);
Vue.component(Spinner.name, Spinner);
Vue.component(Cell.name, Cell);
Vue.component(Popup.name, Popup);
Vue.component(Picker.name, Picker);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Loadmore.name, Loadmore);
Vue.component(Switch.name, Switch);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);


// WEBPACK FOOTER //
// ./src/static/js/mintUi.js